// assets
import { BugFilled,StarFilled,SlidersFilled, FolderFilled  } from "@ant-design/icons";
import { CropIcon } from "./icons";
import Config from '../config.json'


const headers =  {
    "X-API-Key": Config.X_API_KEY,
  }

  const sidebarData = await fetch(`${Config.IPM_SERVER_URL}/api/crops/get-all-crops-with-details`, {
  headers: headers,
});

const data = await sidebarData.json();

// console.log(data.crops, "DATA")

const children = data.crops.map((crop)=> ({
    id: crop?.crop?.id,
    title: crop?.crop?.name,
    icon:  FolderFilled,
    type: "dynamic-item",
    diseaseUrl: crop?.crop?.diseaseUrl,
    pestUrl: crop?.crop?.pestUrl,
    children: {
      diseases: crop?.diseases,
        pests: crop?.pests
    } 
}));

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const crops = {
  id: "dynamic-pages",
  title: "Crops",
  type: "dynamic",
  app: 'ipms',
  children: [
    ...children
  ],
};

export default crops;
